// 筛选框按当前最长选项文字占宽；只改显示，不改值、事件或查询条件。
import {App} from 'vue'
export function optionText(value:any):string {
 if(value==null || typeof value==='boolean')return ''
 if(typeof value==='string' || typeof value==='number')return String(value)
 if(Array.isArray(value))return value.map(optionText).join('')
 if(value.children){const children=value.children;return optionText(typeof children.default==='function'?children.default():children)}
 return ''
}
export function optionLabels(options:any[],field='label'):string[]{
 return (options || []).flatMap(option=>option.options?optionLabels(option.options,field):[optionText(option[field] ?? option.value ?? option)])
}
const filterContext='.query-command,.admin-list-toolbar,.order-filter-row,.filters,.filter-bar,.filter-row,.search-bar,.query-bar,.pinned-filter,[data-filter-width]'
const excluded='.ant-modal,.ant-drawer,.c-modal-cover,.ant-form,form,.ant-pagination,.edit-form'
export function installFilterSelectWidth(app:App){
 const instances=new Set<any>()
 let frame=0
 const canvas=document.createElement('canvas'),context=canvas.getContext('2d')
 function fit(el:HTMLElement,texts:string[]){
  if(!context || !el.isConnected || !el.getClientRects().length)return
  const sample=el.querySelector('.ant-select-selection-item,.ant-select-selection-placeholder') || el
  const style=getComputedStyle(sample);context.font=style.font || [style.fontSize,style.fontFamily].join(' ')
  const spacing=parseFloat(style.letterSpacing)||0
  const longest=Math.max(0,...texts.map(text=>context.measureText(text).width+Math.max(0,text.length-1)*spacing))
  const width=Math.ceil(longest+ (el.tagName==='SELECT'?36:48))
  if(!longest)return
  const px=width+'px'
  for(const name of ['width','min-width','max-width','flex-basis'])if(el.style.getPropertyValue(name)!==px)el.style.setProperty(name,px,'important')
  el.style.setProperty('flex-grow','0','important');el.style.setProperty('flex-shrink','0','important')
  el.dataset.filterWidth='auto'
  const col=el.parentElement
  if(col?.classList.contains('ant-col')){col.style.setProperty('flex','0 0 '+px,'important');col.style.setProperty('min-width',px,'important');col.style.setProperty('max-width',px,'important')}
 }
 function fitInstance(instance:any){
  const el=instance.$el as HTMLElement
  if(!(el instanceof HTMLElement) || el.closest(excluded) || !el.closest(filterContext) || instance.mode==='multiple' || instance.mode==='tags')return
  const props=instance.$.subTree?.props || {},field=instance.fieldNames?.label || 'label'
  const labels=instance.options?optionLabels(instance.options,field):optionNodes(props.children)
  labels.push(optionText(instance.placeholder),el.querySelector('.ant-select-selection-item')?.textContent || '')
  fit(el,labels)
 }
 function optionNodes(nodes:any):string[]{
  if(!nodes)return []
  if(!Array.isArray(nodes))nodes=[nodes]
  return nodes.flatMap((node:any)=>Array.isArray(node.children)?optionNodes(node.children):[optionText(node)])
 }
 function refresh(){frame=0;instances.forEach(fitInstance);document.querySelectorAll<HTMLSelectElement>('select').forEach(el=>{if(el.closest(filterContext) && !el.closest(excluded))fit(el,Array.from(el.options).map(option=>option.text))})}
 function schedule(){if(!frame)frame=requestAnimationFrame(refresh)}
 app.mixin({mounted(){if(this.$options.name==='ASelect'){instances.add(this);schedule()}},updated(){if(this.$options.name==='ASelect')schedule()},beforeUnmount(){instances.delete(this)}})
 const observer=new MutationObserver(schedule)
 observer.observe(document.documentElement,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['lang']})
 window.addEventListener('resize',schedule)
 document.fonts?.ready.then(schedule)
}
